import { createContext } from 'react';
import noop from 'lodash/noop';

type FocusRestorationContextType = {
	shouldRestoreFocus: boolean;
	enableRestoreFocus: () => void;
	clearRestoreFocus: () => void;
};

export const FocusRestorationContext = createContext<FocusRestorationContextType>({
	shouldRestoreFocus: false,
	enableRestoreFocus: noop,
	clearRestoreFocus: noop,
});
